<div class="changelog-create-container">
  <div class="changelog-create-header">
    <h1 class="changelog-create-title">Opret Changelog-indlæg</h1>
    <p class="changelog-create-subtitle">
      Tilføj et nyt changelog-indlæg for at holde brugerne informeret om
      opdateringer.
    </p>
  </div>

  <div class="form-container">
    <form
      [formGroup]="changelogForm"
      (ngSubmit)="onSubmit()"
      class="changelog-form"
    >
      <!-- Title -->
      <div class="form-group">
        <label for="title" class="form-label"
          >Titel <span class="required">*</span></label
        >
        <input
          type="text"
          id="title"
          formControlName="title"
          class="form-control"
          [class.is-invalid]="
            changelogForm.get('title')?.invalid &&
            changelogForm.get('title')?.touched
          "
          placeholder="F.eks., Store ydelsesforbedringer"
        />
        @if (changelogForm.get('title')?.invalid &&
        changelogForm.get('title')?.touched) {
        <div class="error-message">
          @if (changelogForm.get('title')?.errors?.['required']) {
          <span>Titel er påkrævet</span>
          } @if (changelogForm.get('title')?.errors?.['maxlength']) {
          <span>Titel må ikke overstige 100 tegn</span>
          }
        </div>
        }
      </div>

      <!-- Date -->
      <div class="form-group">
        <label for="date" class="form-label"
          >Dato <span class="required">*</span></label
        >
        <input
          type="date"
          id="date"
          formControlName="date"
          class="form-control"
          [class.is-invalid]="
            changelogForm.get('date')?.invalid &&
            changelogForm.get('date')?.touched
          "
        />
        @if (changelogForm.get('date')?.invalid &&
        changelogForm.get('date')?.touched) {
        <div class="error-message">
          @if (changelogForm.get('date')?.errors?.['required']) {
          <span>Dato er påkrævet</span>
          }
        </div>
        }
      </div>

      <!-- Categories -->
      <div class="form-group">
        <label class="form-label"
          >Kategorier <span class="required">*</span></label
        >
        <div class="categories-container">
          @for (category of categories; track category) {
          <button
            type="button"
            class="category-button"
            [class.active]="isCategorySelected(category.value)"
            (click)="toggleCategory(category.value)"
          >
            {{ category.label }}
          </button>
          }
        </div>
        @if (changelogForm.get('categories')?.invalid &&
        changelogForm.get('categories')?.touched) {
        <div class="error-message">
          @if (changelogForm.get('categories')?.errors?.['required']) {
          <span>Vælg mindst én kategori</span>
          }
        </div>
        }
      </div>

      <!-- Description -->
      <div class="form-group">
        <label for="description" class="form-label"
          >Beskrivelse <span class="required">*</span></label
        >
        <textarea
          id="description"
          formControlName="description"
          class="form-control textarea"
          [class.is-invalid]="
            changelogForm.get('description')?.invalid &&
            changelogForm.get('description')?.touched
          "
          placeholder="Kort oversigt over ændringerne"
          rows="3"
        ></textarea>
        @if (changelogForm.get('description')?.invalid &&
        changelogForm.get('description')?.touched) {
        <div class="error-message">
          @if (changelogForm.get('description')?.errors?.['required']) {
          <span>Beskrivelse er påkrævet</span>
          } @if (changelogForm.get('description')?.errors?.['maxlength']) {
          <span>Beskrivelse må ikke overstige 500 tegn</span>
          }
        </div>
        }
      </div>

      <!-- Details -->
      <div class="form-group">
        <label class="form-label"
          >Detaljer <span class="required">*</span></label
        >
        <div formArrayName="details">
          @for (detail of detailsFormArray.controls; track detail; let i =
          $index) {
          <div class="detail-item">
            <div class="detail-input-wrapper">
              <input
                type="text"
                [formControlName]="i"
                class="form-control"
                [class.is-invalid]="detail.invalid && detail.touched"
                placeholder="Tilføj en detalje"
              />
              @if (detailsFormArray.length > 1) {
              <button
                type="button"
                class="remove-detail-button"
                (click)="removeDetailField(i)"
              >
                Fjern
              </button>
              }
            </div>
            @if (detail.invalid && detail.touched) {
            <div class="error-message">
              @if (detail.errors?.['required']) {
              <span>Detalje er påkrævet</span>
              }
            </div>
            }
          </div>
          }
        </div>
        <button
          type="button"
          class="add-detail-button"
          (click)="addDetailField()"
        >
          Tilføj detalje
        </button>
      </div>

      <!-- Submit Button -->
      <div class="form-group">
        <button
          type="submit"
          class="submit-button"
          [disabled]="changelogForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? "Opretter..." : "Opret indlæg" }}
        </button>
      </div>

      <!-- Success/Error Messages -->
      @if (submitSuccess) {
      <div class="alert alert-success">
        Changelog-indlæg oprettet succesfuldt!
      </div>
      } @if (submitError) {
      <div class="alert alert-error">
        {{
          errorMessage ||
            "Kunne ikke oprette changelog-indlæg. Prøv venligst igen."
        }}
      </div>
      }
    </form>
  </div>
</div>
